(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document && !root.MASHalloweenOffer) {
    var node = root.document.getElementById('mas-halloween-offer-config');
    if (node) root.MASHalloweenOffer = api.install(root, JSON.parse(node.textContent));
  }
}(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  function phase(config, now) {
    var time = Number(now);
    return time < Date.parse(config.startsAt) ? 'upcoming' : time >= Date.parse(config.endsAt) ? 'ended' : 'active';
  }
  function owns(line, config) { return line.properties && line.properties._mas_halloween_gift === config.campaign; }
  function topLevelPurchase(line) { return !line.gift_card && !line.selling_plan_allocation && !line.parent_relationship; }
  function ordinary(line) { return topLevelPurchase(line) && !(line.item_components || []).length; }
  function variant(line) { return String(line.variant_id || line.id); }
  function quantity(line) { return Number.isSafeInteger(Number(line.quantity)) && Number(line.quantity) > 0 ? Number(line.quantity) : 0; }
  function cartSignature(cart) {
    return JSON.stringify([cart.item_count, cart.total_price, cart.total_discount, cart.items.map(function (line) {
      return [line.key, variant(line), quantity(line), line.original_line_price, line.final_line_price, line.line_level_discount_allocations || []];
    })]);
  }
  function rowsMatch(rows, cart) {
    return rows.length === cart.items.length && Array.from(rows).every(function (row, index) {
      var line = cart.items[index], data = row.dataset;
      return data.masCartKey === line.key && Number(data.masCartQuantity) === quantity(line) && Number(data.masCartFinalLinePrice) === Number(line.final_line_price);
    });
  }
  var migrationAttribute = '_mas_bundle15_migration';
  function bundleMode(config) { return config.mode === 'bundle15'; }
  function emptyProperties(line) { return !Object.keys(line.properties || {}).some(function (key) { return line.properties[key] !== '' && line.properties[key] != null; }); }
  function tokenHash(cart) {
    var value = String(cart.token || ''), hash = 2166136261;
    for (var index = 0; index < value.length; index++) hash = Math.imul(hash ^ value.charCodeAt(index), 16777619);
    return value ? String(hash >>> 0) : '';
  }
  function bundleGroups(cart, config) {
    return config.offers.map(function (offer) {
      var old = cart.items.filter(function (line) { return variant(line) === String(offer.packVariant) && !owns(line, config); });
      var promo = cart.items.filter(function (line) { return variant(line) === String(offer.promoVariant) && !owns(line, config); });
      var plain = promo.filter(emptyProperties);
      var sum = function (lines) { return lines.reduce(function (total, line) { return total + quantity(line); }, 0); };
      return { offer: offer, old: old, promo: promo, plain: plain, oldCount: sum(old), promoCount: sum(promo), plainCount: sum(plain) };
    });
  }
  function migrationIntent(cart, config) {
    var value = cart.attributes && cart.attributes[migrationAttribute];
    if (!value) return null;
    try {
      var intent = JSON.parse(value);
      if (intent.version !== 1 || intent.campaign !== config.campaign || !intent.token || intent.token !== tokenHash(cart) || !Array.isArray(intent.groups) || !intent.groups.length) throw new Error();
      var seen = new Set();
      intent.groups.forEach(function (entry) {
        var offer = config.offers.find(function (item) { return String(item.promoVariant) === entry.promo; });
        if (!offer || seen.has(entry.promo) || String(offer.packVariant) !== entry.old || ![entry.before, entry.source, entry.target].every(function (count) { return Number.isSafeInteger(count) && count >= 0; }) || entry.source < 1 || entry.target !== entry.before + entry.source) throw new Error();
        seen.add(entry.promo);
      });
      return intent;
    } catch (_) { return { invalid: true }; }
  }
  function nextBundleOperation(cart, config, now, recover) {
    var list = bundleGroups(cart, config), owned = cart.items.filter(function (line) { return owns(line, config); });
    var intent = migrationIntent(cart, config);
    var blocked = function (reason) { return { type: 'blocked', reason: reason }; };
    if (config.currency && cart.currency && config.currency !== cart.currency && (intent || owned.length || list.some(function (group) { return group.promoCount || (phase(config, now) === 'active' && group.oldCount); }))) return blocked('currencyMismatch');
    if (intent && intent.invalid) return blocked('migrationConflict');
    if (intent && phase(config, now) !== 'active') return blocked('offerEnded');
    if (!intent) {
      var sources = list.filter(function (group) { return group.oldCount > 0; });
      if (phase(config, now) !== 'active') sources = [];
      if (!sources.length) {
        if (!owned.length) return null;
        var staleUpdates = {};
        owned.forEach(function (line) { staleUpdates[line.key] = 0; });
        return { type: 'update', body: { updates: staleUpdates } };
      }
      if (!tokenHash(cart)) return blocked('migrationError');
      if (sources.some(function (group) { return group.old.some(function (line) { return !topLevelPurchase(line) || !emptyProperties(line); }) || (group.promo.length && !group.plain.length); })) return blocked('customPack');
      intent = { version: 1, campaign: config.campaign, token: tokenHash(cart), groups: sources.map(function (group) { return { old: String(group.offer.packVariant), promo: String(group.offer.promoVariant), source: group.oldCount, before: group.plainCount, target: group.oldCount + group.plainCount }; }) };
      var attributes = {}; attributes[migrationAttribute] = JSON.stringify(intent);
      return { type: 'update', body: { attributes: attributes }, stage: 'prepare' };
    }
    var progress = intent.groups.map(function (entry) { return { intent: entry, group: list.find(function (group) { return String(group.offer.promoVariant) === entry.promo; }) }; });
    if (progress.some(function (entry) { return entry.group.old.some(function (line) { return !topLevelPurchase(line) || !emptyProperties(line); }) || (entry.group.promo.length && !entry.group.plain.length); })) return blocked('customPack');
    if (progress.some(function (entry) { return entry.group.oldCount > entry.intent.source || entry.group.plainCount > entry.intent.target || entry.group.plainCount < entry.intent.before; })) return blocked('migrationConflict');
    var pendingOwned = owned.filter(function (line) { return intent.groups.some(function (entry) { return entry.old === String(line.properties._mas_halloween_pair); }); });
    var complete = progress.every(function (entry) { return entry.group.oldCount === 0 && entry.group.plainCount === entry.intent.target; }) && !pendingOwned.length;
    if (complete) {
      var clear = {}; clear[migrationAttribute] = '';
      return { type: 'update', body: { attributes: clear }, stage: 'complete' };
    }
    var initial = progress.every(function (entry) { return entry.group.oldCount === entry.intent.source && entry.group.plainCount === entry.intent.before; });
    if (progress.some(function (entry) { return entry.group.oldCount > 0 && entry.group.plainCount > entry.intent.before; })) return blocked('migrationConflict');
    if (!initial && !recover) return blocked('migrationError');
    var updates = {};
    progress.forEach(function (entry) {
      var group = entry.group;
      group.old.forEach(function (line) { updates[line.key] = 0; });
      if (group.plainCount !== entry.intent.target) {
        var first = group.plain[0];
        updates[first ? first.key : entry.intent.promo] = (first ? quantity(first) : 0) + entry.intent.target - group.plainCount;
      }
    });
    owned.forEach(function (line) { updates[line.key] = 0; });
    return { type: 'update', body: { updates: updates }, stage: 'replace' };
  }
  function cancelMigrationOperation(cart, config, now) {
    if (!migrationIntent(cart, config)) return null;
    if (phase(config, now) === 'active' && bundleGroups(cart, config).some(function (group) { return group.oldCount > 0; })) return { type: 'blocked', reason: 'cancelRemoveOld' };
    var attributes = {}; attributes[migrationAttribute] = '';
    return { type: 'update', body: { attributes: attributes }, stage: 'cancel' };
  }
  function inspectBundle(cart, config, now) {
    var list = bundleGroups(cart, config), pending = nextBundleOperation(cart, config, now);
    var failed = list.filter(function (group) {
      return group.promo.some(function (line) {
        var components = line.item_components || [];
        return !topLevelPurchase(line) || group.offer.units !== 15 || !Number.isSafeInteger(group.offer.unitPrice) || Number(line.original_line_price) !== group.offer.unitPrice * quantity(line) || !Number.isFinite(Number(line.final_line_price)) || Number(line.final_line_price) < 0 || Number(line.final_line_price) > Number(line.original_line_price) || (components.length && (components.length !== 1 || variant(components[0]) !== String(group.offer.giftVariant) || ![group.offer.units, group.offer.units * quantity(line)].includes(quantity(components[0]))));
      });
    });
    var expired = phase(config, now) !== 'active' && list.some(function (group) { return group.promoCount > 0; });
    var errorCode = pending && pending.type === 'blocked' ? pending.reason : expired ? 'offerEnded' : failed.length ? 'bundleError' : '';
    return { ok: !pending && !errorCode, pending: pending, discountFailures: [], errorCode: errorCode, groups: list, relevant: list.some(function (group) { return group.promoCount || (phase(config, now) === 'active' && group.oldCount); }) || !!migrationIntent(cart, config) || cart.items.some(function (line) { return owns(line, config); }), phase: phase(config, now) };
  }
  function needsSync(cart, config, now) {
    if (bundleMode(config)) return inspectBundle(cart, config, now).relevant;
    if (cart.items.some(function (line) { return owns(line, config); })) return true;
    return phase(config, now) === 'active' && groups(cart, config).some(function (group) { return group.packCount > 0; });
  }
  function mutationCouldQualify(body, config) {
    if (body == null) return true;
    var ids = [];
    if (typeof body === 'string') {
      try { body = JSON.parse(body); }
      catch (_) { body = new URLSearchParams(body); }
    }
    if (body && typeof body.entries === 'function') {
      for (var pair of body.entries()) {
        if (pair[0] === 'id' || /\[id\]$/.test(pair[0])) ids.push(pair[1]);
        var updateKey = pair[0].match(/^updates\[(.+)\]$/);
        if (updateKey) ids.push(updateKey[1]);
      }
    } else if (body && Object.prototype.toString.call(body) === '[object Object]') {
      if (body.id != null) ids.push(body.id);
      if (Array.isArray(body.items)) body.items.forEach(function (item) { if (item && item.id != null) ids.push(item.id); });
      if (body.updates && !Array.isArray(body.updates)) ids.push.apply(ids, Object.keys(body.updates));
    } else return true;
    return ids.some(function (id) { return config.offers.some(function (offer) { return String(id).split(':')[0] === String(offer.packVariant) || (bundleMode(config) && String(id).split(':')[0] === String(offer.promoVariant)); }); });
  }
  function groups(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return config.offers.map(function (offer) {
      var packs = items.filter(function (line) { return variant(line) === String(offer.packVariant) && !owns(line, config) && topLevelPurchase(line); });
      var gifts = items.filter(function (line) { return owns(line, config) && ordinary(line) && variant(line) === String(offer.giftVariant) && String(line.properties._mas_halloween_pair) === String(offer.packVariant); });
      var singles = items.filter(function (line) { return ordinary(line) && variant(line) === String(offer.giftVariant); });
      var packCount = packs.reduce(function (sum, line) { return sum + quantity(line); }, 0);
      var giftCount = gifts.reduce(function (sum, line) { return sum + quantity(line); }, 0);
      return { offer: offer, packs: packs, gifts: gifts, singles: singles, packCount: packCount, giftCount: giftCount, target: packCount * 5 };
    });
  }
  function nextOperation(cart, config, now, recover) {
    if (bundleMode(config)) return nextBundleOperation(cart, config, now, recover);
    var active = phase(config, now) === 'active';
    var list = groups(cart, config);
    var known = new Set(list.flatMap(function (group) { return group.gifts; }));
    var stale = cart.items.find(function (line) { return owns(line, config) && (!active || !known.has(line)); });
    if (stale) return { type: 'change', id: stale.key, quantity: 0 };
    if (!active) return null;
    for (var group of list) {
      if (group.giftCount > group.target) {
        var excess = group.gifts.reduce(function (candidate, line) {
          return (Number(line.final_line_price) || 0) > (Number(candidate.final_line_price) || 0) ? line : candidate;
        }, group.gifts[0]);
        return { type: 'change', id: excess.key, quantity: Math.max(0, quantity(excess) - (group.giftCount - group.target)) };
      }
    }
    for (var entry of list) {
      var existing = entry.gifts[0];
      var amount = entry.giftCount;
      if (amount < entry.target) {
        return { type: 'add', id: String(entry.offer.giftVariant), quantity: entry.target - amount, properties: existing ? Object.assign({}, existing.properties) : { _mas_halloween_gift: config.campaign, _mas_halloween_pair: String(entry.offer.packVariant) } };
      }
    }
    return null;
  }
  function inspect(cart, config, now) {
    if (bundleMode(config)) return inspectBundle(cart, config, now);
    var list = groups(cart, config);
    var active = phase(config, now) === 'active';
    var pending = nextOperation(cart, config, now);
    var failed = [];
    if (active && !pending) list.forEach(function (group) {
      if (!group.target) return;
      var expected = group.gifts.reduce(function (sum, line) { return sum + Number(line.original_line_price); }, 0);
      var discount = group.singles.reduce(function (sum, line) {
        return sum + (line.line_level_discount_allocations || []).reduce(function (total, allocation) {
          return total + (allocation.discount_application && allocation.discount_application.title === group.offer.discountTitle ? Number(allocation.amount) || 0 : 0);
        }, 0);
      }, 0);
      var shifted = group.gifts.some(function (line) { return Number(line.final_line_price) > 0; });
      group.allocationOnPaidSingles = shifted;
      if (!Number.isFinite(expected) || expected <= 0 || discount < expected) failed.push(group.offer.label);
    });
    return { ok: !pending && !failed.length, pending: pending, discountFailures: failed, groups: list, relevant: list.some(function (group) { return group.packCount || group.gifts.length; }) || cart.items.some(function (line) { return owns(line, config); }), phase: phase(config, now) };
  }
  async function reconcile(adapter, config, now, interrupted, recover) {
    var cart = await adapter.read();
    for (var count = 0; count < 32; count++) {
      if (interrupted && interrupted()) return { interrupted: true, cart: cart };
      var operation = nextOperation(cart, config, now(), recover);
      if (!operation) return { cart: cart, audit: inspect(cart, config, now()) };
      if (operation.type === 'blocked') { var error = new Error(operation.reason); error.code = operation.reason; throw error; }
      await adapter.mutate(operation);
      cart = await adapter.read();
    }
    throw new Error('unstable');
  }
  function install(win, config) {
    var doc = win.document;
    var request = win.fetch.bind(win);
    var route = ((win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || config.root || '/').replace(/\/?$/, '/');
    var serverOffset = Number(config.serverNow) * 1000 - Date.now();
    var latest = config.cart || { items: [] };
    var audit = inspect(latest, config, now());
    var state = 'idle', message = '', flight = null, dirty = false, refreshNeeded = false, nativePending = 0, pendingOfferMutations = 0, uncertainOfferMutation = false, timer = null, checkingOut = false;
    var quantityWarning = '', mutationVersion = 0, publishPending = false;
    var renderedSignature = cartSignature(latest), focusTimer = null, publishing = false;
    var migrationRecovery = false;
    var observedOfferKeys = new Set();
    var waiters = [];
    function rememberOfferKeys(cart) {
      cart.items.forEach(function (line) {
        if (owns(line, config) || config.offers.some(function (offer) { return variant(line) === String(offer.packVariant) || (bundleMode(config) && variant(line) === String(offer.promoVariant)); })) observedOfferKeys.add(line.key);
      });
    }
    rememberOfferKeys(latest);
    function now() { return Date.now() + serverOffset; }
    function text(key, replacements) {
      var value = config.messages[key] || (key === 'currencyMismatch' ? 'Please refresh this page to confirm prices in your selected currency.' : key);
      Object.keys(replacements || {}).forEach(function (name) { value = value.replaceAll('{' + name + '}', String(replacements[name])); });
      return value;
    }
    function updateClock(response) {
      var remote = Date.parse(response.headers.get('date'));
      if (Number.isFinite(remote)) serverOffset = remote - Date.now();
    }
    async function json(url, options) {
      var response = await request(url, Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options));
      updateClock(response);
      var data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : text('requestError'));
      return data;
    }
    var adapter = {
      read: async function () {
        var cart = await json(route + 'cart.js');
        if (!Array.isArray(cart.items)) throw new Error(text('requestError'));
        latest = cart;
        rememberOfferKeys(latest);
        if (!nativePending) uncertainOfferMutation = false;
        return cart;
      },
      mutate: async function (operation) {
        publishPending = true;
        var body = operation.type === 'update' ? operation.body : operation.type === 'add' ? { items: [{ id: operation.id, quantity: operation.quantity, properties: operation.properties }] } : { id: operation.id, quantity: operation.quantity };
        return json(route + 'cart/' + operation.type + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      }
    };
    function settle(error) {
      migrationRecovery = false;
      var callbacks = waiters.splice(0);
      callbacks.forEach(function (entry) { error ? entry.reject(error) : entry.resolve(latest); });
    }
    function sections() {
      var ids = [];
      doc.dispatchEvent(new win.CustomEvent('cart:push:section.id', { detail: { sections: ids } }));
      doc.querySelectorAll('#CartDrawer[section-id], #CartPage-Form[section-id]').forEach(function (element) { ids.push(element.getAttribute('section-id')); });
      return Array.from(new Set(ids.filter(Boolean))).slice(0, 5);
    }
    function cartViews(root) { return Array.from(root.querySelectorAll('#CartDrawer, #hdt-page-cart')); }
    function viewsMatch(root, cart) {
      return cartViews(root).every(function (view) { return rowsMatch(view.querySelectorAll('[data-mas-cart-key]'), cart); });
    }
    function viewHasObservedOffer() {
      return cartViews(doc).some(function (view) { return Array.from(view.querySelectorAll('[data-mas-cart-key]')).some(function (row) { return observedOfferKeys.has(row.dataset.masCartKey); }); });
    }
    function waitForPaint(cart) {
      if (viewsMatch(doc, cart)) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var timeout;
        function finish(error) {
          win.clearTimeout(timeout);
          doc.removeEventListener('cart:drawer:render', check);
          doc.removeEventListener('cart:page:render', check);
          error ? reject(error) : resolve();
        }
        function check() { if (viewsMatch(doc, cart)) finish(); }
        doc.addEventListener('cart:drawer:render', check);
        doc.addEventListener('cart:page:render', check);
        timeout = win.setTimeout(function () { finish(new Error(text('renderError'))); }, 1500);
      });
    }
    async function publish() {
      var ids = sections();
      if (ids.length) {
        var url = new win.URL(win.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        var cart = await json(route + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ sections: ids, sections_url: url.pathname + url.search }) });
        if (!Array.isArray(cart.items) || !cart.sections || ids.some(function (id) { return typeof cart.sections[id] !== 'string'; })) throw new Error(text('renderError'));
        latest = cart; rememberOfferKeys(latest); audit = inspect(latest, config, now());
        if (audit.pending && audit.pending.type !== 'blocked') { if (!bundleMode(config)) dirty = true; return false; }
        if (ids.some(function (id) { return !viewsMatch(new win.DOMParser().parseFromString(cart.sections[id], 'text/html'), cart); })) throw new Error(text('renderError'));
        if (nativePending || dirty) return false;
        publishing = true;
        try {
          doc.dispatchEvent(new win.CustomEvent('cart:change', { bubbles: true, detail: { cart: cart, baseEvent: 'halloween:sync', masHalloweenSynced: true } }));
          await waitForPaint(cart);
        } finally { publishing = false; }
      }
      renderedSignature = cartSignature(latest);
      return true;
    }
    function setState(next, detail) {
      detail = detail || '';
      if (state === next && message === detail) return;
      state = next; message = detail; render();
    }
    function withCartLock(action) {
      if (bundleMode(config) && win.navigator && win.navigator.locks && tokenHash(latest)) return win.navigator.locks.request('mas-bundle15-' + tokenHash(latest), action);
      return Promise.resolve().then(action);
    }
    function start() {
      if (flight || nativePending || !dirty) return;
      flight = withCartLock(async function () {
        while (dirty && !nativePending) {
          dirty = false;
          var wasRelevant = needsSync(latest, config, now()) || uncertainOfferMutation;
          var shouldRead = refreshNeeded || wasRelevant || publishPending;
          refreshNeeded = false;
          if (!shouldRead) { audit = inspect(latest, config, now()); setState('ready'); settle(); continue; }
          if (wasRelevant || publishPending) setState('busy');
          var result = await reconcile(adapter, config, now, function () { return nativePending > 0 || dirty; }, migrationRecovery);
          if (result.interrupted) { dirty = true; break; }
          latest = result.cart; audit = result.audit;
          if ((wasRelevant || needsSync(latest, config, now())) && (renderedSignature !== cartSignature(latest) || !viewsMatch(doc, latest))) publishPending = true;
          if (publishPending) {
            if (await publish()) publishPending = false;
          }
          if (nativePending || dirty) continue;
          if (!audit.ok) throw new Error(audit.errorCode ? text(audit.errorCode) : audit.discountFailures.length ? text('discountError', { varieties: audit.discountFailures.join(', ') }) : text('requestError'));
          setState('ready');
          settle();
        }
      }).catch(async function (error) {
        dirty = false;
        if (needsSync(latest, config, now()) || uncertainOfferMutation || publishPending) {
          try { await withCartLock(async function () { latest = await adapter.read(); if (await publish()) publishPending = false; }); } catch (_) {}
        }
        audit = inspect(latest, config, now());
        if (needsSync(latest, config, now()) || uncertainOfferMutation || publishPending) {
          setState('blocked', text('blocked', { reason: error.code ? text(error.code) : error.message }));
          settle(error);
        } else { setState('ready'); settle(); }
      }).finally(function () {
        flight = null;
        if (dirty && !nativePending) start();
      });
    }
    function schedule(forceRead) {
      if (forceRead === true) refreshNeeded = true;
      dirty = true;
      if (needsSync(latest, config, now()) || uncertainOfferMutation || publishPending) setState('busy');
      win.clearTimeout(timer);
      timer = win.setTimeout(start, 0);
    }
    function ensure(recover) {
      if (recover === true) migrationRecovery = true;
      var promise = new Promise(function (resolve, reject) { waiters.push({ resolve: resolve, reject: reject }); });
      schedule(true);
      return promise;
    }
    async function cancelMigration() {
      if (!bundleMode(config)) return;
      try {
        publishPending = true; setState('busy');
        await withCartLock(async function () {
          latest = await adapter.read();
          var operation = cancelMigrationOperation(latest, config, now());
          if (operation && operation.type === 'blocked') { var error = new Error(text(operation.reason)); error.code = operation.reason; throw error; }
          if (operation) await adapter.mutate(operation);
          latest = await adapter.read();
          if (migrationIntent(latest, config)) throw new Error(text('migrationError'));
        });
        await ensure();
      } catch (error) { setState('blocked', text('blocked', { reason: error.code ? text(error.code) : error.message })); throw error; }
    }
    function cartMutation(input, options) {
      try {
        var url = new win.URL(typeof input === 'string' || input instanceof win.URL ? input : input.url, win.location.href);
        var method = String(options && options.method || input && input.method || 'GET').toUpperCase();
        var match = url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/);
        return method === 'POST' && url.origin === win.location.origin && match && match[1];
      } catch (_) { return false; }
    }
    win.fetch = function (input, options) {
      var mutation = cartMutation(input, options);
      if (!mutation) return request(input, options);
      var potential = mutation !== 'clear' && phase(config, now()) === 'active' && mutationCouldQualify(options && options.body, config);
      var relevantMutation = potential || guarded();
      var warningVersion = relevantMutation ? ++mutationVersion : 0;
      var rejected = false;
      if (relevantMutation) quantityWarning = '';
      nativePending++;
      if (potential) { pendingOfferMutations++; uncertainOfferMutation = true; }
      if (guarded()) setState('busy');
      var nativeRequest = relevantMutation ? withCartLock(function () { return request(input, options); }) : request(input, options);
      return nativeRequest.then(async function (response) {
        if (response.status === 422 && relevantMutation) {
          rejected = true;
          var reason = text('requestError');
          try {
            var error = await response.clone().json();
            if (typeof error.description === 'string') reason = error.description;
            else if (typeof error.message === 'string') reason = error.message;
          } catch (_) {}
          if (warningVersion === mutationVersion) quantityWarning = reason;
        }
        return response;
      }).finally(function () { nativePending--; if (potential) pendingOfferMutations--; schedule(potential || rejected); });
    };
    function guarded() { return publishPending || needsSync(latest, config, now()) || (phase(config, now()) === 'active' && (pendingOfferMutations > 0 || uncertainOfferMutation)); }
    async function checkout(form) {
      if (checkingOut) return;
      checkingOut = true;
      try {
        if (form && !form.reportValidity()) return;
        if (win.MASCartNote) await win.MASCartNote.flush();
        await ensure();
        if (state === 'ready' && audit.ok && !nativePending && !dirty) win.location.assign(route + 'checkout');
      } catch (_) { render(true); }
      finally { checkingOut = false; }
    }
    function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
    win.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      if (!guarded() || !submitter || submitter.name !== 'checkout') return;
      stop(event); checkout(event.target);
    }, true);
    win.addEventListener('click', function (event) {
      if (!guarded() || event.button !== 0) return;
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var url = new win.URL(link.href, win.location.href);
      if (url.origin === win.location.origin && /\/checkouts?(?:\/|$)/.test(url.pathname)) { stop(event); checkout(null); }
    }, true);
    doc.addEventListener('cart:change', function (event) {
      if (!event.detail || event.detail.masHalloweenSynced) return;
      if (event.detail.cart && Array.isArray(event.detail.cart.items)) latest = event.detail.cart;
      rememberOfferKeys(latest);
      audit = inspect(latest, config, now());
      if (guarded() && audit.relevant && event.detail.baseEvent === 'variant:add') event.detail.actionAfterATC = 'open_cart_drawer';
      schedule();
    }, true);
    win.addEventListener('variant:add', function (event) {
      if (!event.detail || !guarded()) return;
      var cart = event.detail.cart || latest;
      if (inspect(cart, config, now()).relevant) event.detail.actionAfterATC = doc.getElementById('CartDrawer') ? 'open_cart_drawer' : 'go_cart_page';
    }, true);
    function badge(row, wording) {
      var node = row.querySelector('[data-mas-halloween-line]');
      if (!wording) { if (node) node.remove(); return; }
      if (!node) { node = doc.createElement('p'); node.dataset.masHalloweenLine = ''; node.className = 'mas-halloween-line'; (row.querySelector('.hdt-mini-cart__info, .hdt-page-cart__info') || row).appendChild(node); }
      if (node.textContent !== wording) node.textContent = wording;
    }
    function render(focus) {
      var current = inspect(latest, config, now());
      var relevant = current.relevant;
      var lock = publishPending || (relevant && (current.phase === 'active' || bundleMode(config))) || latest.items.some(function (line) { return owns(line, config); });
      var product = config.offers.some(function (offer) { return String(offer.productId) === String(config.productId); });
      doc.documentElement.classList.toggle('mas-halloween-pdp-active', product && current.phase === 'active');
      var configNode = doc.getElementById('mas-halloween-offer-config');
      if (configNode) {
        var activeProduct = String(product && current.phase === 'active'), activeCart = String(lock);
        if (configNode.dataset.activeProduct !== activeProduct) configNode.dataset.activeProduct = activeProduct;
        if (configNode.dataset.activeCart !== activeCart) configNode.dataset.activeCart = activeCart;
      }
      doc.documentElement.classList.toggle('mas-halloween-cart-active', lock);
      doc.documentElement.classList.toggle('mas-halloween-cart-busy', lock && (state === 'busy' || publishPending));
      doc.querySelectorAll('[name="checkout"], a[href="/checkout"]').forEach(function (element) {
        if (lock && state !== 'ready') element.setAttribute('aria-disabled', 'true');
        else element.removeAttribute('aria-disabled');
      });
      var wording = state === 'blocked' ? message : current.phase === 'upcoming' ? text('upcoming') : current.phase === 'ended' ? '' : state === 'busy' ? text(bundleMode(config) && current.pending ? 'migrating' : 'checking') : bundleMode(config) ? '' : text('confirmed');
      if (current.phase === 'active' && state === 'ready' && current.groups.some(function (group) { return group.allocationOnPaidSingles; })) wording += ' ' + text('allocation');
      if (!relevant && !uncertainOfferMutation && !publishPending) wording = '';
      if (quantityWarning) wording += (wording ? ' ' : '') + text('quantityAdjusted', { reason: quantityWarning });
      var cancellation = bundleMode(config) && state === 'blocked' && migrationIntent(latest, config) ? cancelMigrationOperation(latest, config, now()) : null;
      if (cancellation) {
        var counts = bundleGroups(latest, config).reduce(function (total, group) { total.packs += group.promoCount; total.oldPacks += group.oldCount; return total; }, { packs: 0, oldPacks: 0 });
        wording += ' ' + text('cancelSummary', counts);
        if (cancellation.type === 'blocked') wording += ' ' + text('cancelRemoveOld');
      }
      doc.querySelectorAll('#CartDrawer .hdt-mini-cart__sroll, #hdt-page-cart .hdt-cart-page__items').forEach(function (host) {
        var panel = host.querySelector(':scope > [data-mas-halloween-status]');
        if (!wording) { if (panel) panel.remove(); return; }
        if (!panel) {
          panel = doc.createElement('aside'); panel.dataset.masHalloweenStatus = ''; panel.className = 'mas-halloween-status'; panel.setAttribute('role', 'status'); panel.setAttribute('aria-live', 'polite'); panel.tabIndex = -1;
          var copy = doc.createElement('p'); panel.appendChild(copy);
          var retry = doc.createElement('button'); retry.type = 'button'; retry.textContent = text('retry'); retry.addEventListener('click', function () { ensure(true).catch(function () {}); }); panel.appendChild(retry); host.prepend(panel);
          if (bundleMode(config)) {
            var cancel = doc.createElement('button'); cancel.type = 'button'; cancel.dataset.masHalloweenCancel = ''; cancel.textContent = text('cancelMigration'); cancel.hidden = true;
            cancel.addEventListener('click', function () { cancelMigration().catch(function () {}); }); panel.appendChild(cancel);
          }
        }
        if (panel.dataset.state !== state) panel.dataset.state = state;
        if (panel.querySelector('p').textContent !== wording) panel.querySelector('p').textContent = wording;
        panel.querySelector('button').hidden = state !== 'blocked';
        var cancelButton = panel.querySelector('[data-mas-halloween-cancel]');
        if (cancelButton) { cancelButton.hidden = !cancellation; cancelButton.disabled = !!cancellation && cancellation.type === 'blocked'; }
        if (focus) panel.focus({ preventScroll: false });
      });
      var lines = new Map(latest.items.map(function (line) { return [line.key, line]; }));
      doc.querySelectorAll('#CartDrawer [data-mas-cart-key], #hdt-page-cart [data-mas-cart-key]').forEach(function (row) {
        var line = lines.get(row.dataset.masCartKey);
        if (!line || !rowsMatch([row], { items: [line] })) { row.classList.toggle('mas-halloween-gift-line', false); badge(row, ''); return; }
        var gift = owns(line, config);
        var offer = topLevelPurchase(line) && config.offers.find(function (entry) { return String(bundleMode(config) ? entry.promoVariant : entry.packVariant) === variant(line); });
        var wording = gift ? (bundleMode(config) ? '' : text('bonus', { count: quantity(line) })) : offer && current.phase === 'active' && state === 'ready' ? text(bundleMode(config) ? 'bundleLine' : 'pack', { paid: quantity(line) * 10, free: quantity(line) * 5, total: quantity(line) * 15 }) : '';
        row.classList.toggle('mas-halloween-gift-line', gift); badge(row, wording);
      });
    }
    ['cart:drawer:render', 'cart:page:render', 'shopify:section:load'].forEach(function (name) { doc.addEventListener(name, function () {
      if (!publishing && (guarded() || viewHasObservedOffer()) && !viewsMatch(doc, latest)) { publishPending = true; schedule(true); }
      else if (viewsMatch(doc, latest)) renderedSignature = cartSignature(latest);
      render();
    }); });
    function refreshFromOtherTab() {
      if (doc.hidden) return;
      if (bundleMode(config) && !guarded()) return;
      win.clearTimeout(focusTimer);
      focusTimer = win.setTimeout(function () { schedule(phase(config, now()) === 'active'); }, 125);
    }
    win.addEventListener('pageshow', function (event) { if (event.persisted) refreshFromOtherTab(); });
    win.addEventListener('focus', refreshFromOtherTab);
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) refreshFromOtherTab(); });
    [Date.parse(config.startsAt), Date.parse(config.endsAt)].filter(function (time) { return time > now(); }).forEach(function (time) { win.setTimeout(schedule, Math.min(time - now() + 1000, 2147483647)); });
    setState(needsSync(latest, config, now()) ? 'busy' : 'ready');
    if (doc.readyState === 'complete') schedule();
    else doc.addEventListener('DOMContentLoaded', schedule, { once: true });
    return { sync: ensure, cancelMigration: cancelMigration, getState: function () { return { status: state, phase: phase(config, now()), relevant: audit.relevant, ready: state === 'ready' && audit.ok, error: message }; }, version: '2026-10-25' };
  }
  return { phase: phase, groups: groups, needsSync: needsSync, mutationCouldQualify: mutationCouldQualify, nextOperation: nextOperation, inspect: inspect, reconcile: reconcile, cartSignature: cartSignature, rowsMatch: rowsMatch, install: install, bundleGroups: bundleGroups, migrationIntent: migrationIntent, cancelMigrationOperation: cancelMigrationOperation };
}));
